import React from 'react';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';

export default class  ErrorFrame extends React.Component{

    constructor(props){
        super(props);
    }

    onRetry(){
        if(this.props.onRetry)
        this.props.onRetry();
    }

    render() {
        return(<div className="text-center animated fadeIn">
            <img src={"/img/error_frame_logo.png"} width={42} height={42}></img>
            <h5 style={{'marginTop' :'15px'}}>{this.props.message || "Ooops! Seems an error occurred!"}</h5>
            <Button onClick={this.onRetry.bind(this)}  className="btn-primary"><i className="fa fa-refresh"></i> {this.props.retryLabel || "Retry" }</Button>
        </div>);
    }

}

ErrorFrame.propTypes = {
    message : PropTypes.bool,
    allowRetry : PropTypes.bool,
    retryLabel : PropTypes.string,
    onRetry: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/components/ErrorFrame/ErrorFrame.js